export const removeUUID = (path?: string): string => {
  if (!path) {
    return '';
  }
  const uuidLen = 36;
  if (path.lastIndexOf('/') + uuidLen === path.length - 1) {
    return path.substring(0, path.lastIndexOf('/'));
  }
  return path;
};
